export default __webpack_public_path__ + "media/images/admin/white-triangle-9f3c967f99001a13ed4a3f32cbbcc589.svg";